// ** React Imports
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// ** Custom Components
// import Avatar from "@components/avatar";
import { Avatar } from "@nextui-org/react";
// ** Utils
import { isUserLoggedIn } from "@utils";

// ** Store & Actions
import { handleLogout } from "@store/authentication";
import { useDispatch } from "react-redux";
// ** Third Party Components
import { Key, Power, Settings } from "react-feather";

import { getUserName } from "../../../../auth/LoginUser";

// ** Reactstrap Imports
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

// ** Default Avatar Image
import { setImageFromUrl } from "../../../../components/common/ImageFromURL";

const UserDropdown = () => {
  // ** Store Vars
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);

  //** ComponentDidMount
  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setImageFromUrl(`${getUserName()}`, setImage);
    }
  }, []);

  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item" size="sm">
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}
      >
        <Avatar
          // css={{ size: '$17' }}
          style={{ marginLeft: "-10px" }}
          size="lg"
          zoomed
          src={image}
          color="gradient"
          bordered
        />
      </DropdownToggle>
      <DropdownMenu end>
        {/* <UserGroupDropDown /> */}
        <DropdownItem tag={Link} to="/pages/reset-password-basic">
          <Key size={14} className="me-75" />
          <span className="align-middle">Change Password</span>
        </DropdownItem>
        <DropdownItem tag={Link} to="/setting-email">
          <Settings size={14} className="me-75" />
          <span className="align-middle">Setting</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          tag={Link}
          to="/login"
          onClick={() => dispatch(handleLogout())}
        >
          <Power size={14} className="me-75" />
          <span className="align-middle">Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
